const ACTIVE_CLASS = 'is-active';

const requestFrame =
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  function (callback) {
    return window.setTimeout(callback, 16);
  };

function getParts(item) {
  return {
    trigger: item.querySelector('[data-accordion-toggle]'),
    panel: item.querySelector('[data-accordion-panel]'),
  };
}

function expandItem(item, skipAnimation = false) {
  const { trigger, panel } = getParts(item);

  if (!trigger || !panel) {
    return;
  }

  const wasHidden = panel.hidden;

  item.classList.add(ACTIVE_CLASS);
  trigger.setAttribute('aria-expanded', 'true');
  panel.hidden = false;

  if (skipAnimation) {
    panel.style.height = 'auto';
    return;
  }

  // Start from the current rendered height so an interrupted collapse
  // reverses smoothly; a fully closed panel starts from 0.
  panel.style.height = wasHidden ? '0px' : `${panel.offsetHeight}px`;

  // Force reflow so the starting height is committed before animating.
  void panel.offsetHeight;

  requestFrame(() => {
    panel.style.height = `${panel.scrollHeight}px`;
  });
}

function collapseItem(item) {
  const { trigger, panel } = getParts(item);

  if (!trigger || !panel || !item.classList.contains(ACTIVE_CLASS)) {
    return;
  }

  item.classList.remove(ACTIVE_CLASS);
  trigger.setAttribute('aria-expanded', 'false');

  // Pin the current height (in case it is `auto`) before animating to 0.
  panel.style.height = `${panel.offsetHeight}px`;

  void panel.offsetHeight;

  requestFrame(() => {
    panel.style.height = '0px';
  });
}

// One persistent listener per panel that reconciles the final state from the
// current `is-active` class, so interrupted/rapid toggles never leave the
// panel in a broken half-open state.
function handleTransitionEnd(item, panel, event) {
  if (event.propertyName !== 'height') {
    return;
  }

  if (item.classList.contains(ACTIVE_CLASS)) {
    panel.style.height = 'auto';
  } else {
    panel.hidden = true;
    panel.style.height = '';
  }
}

export function initAccordions() {
  const groups = document.querySelectorAll('[data-accordion-group]');

  if (!groups.length) {
    return;
  }

  groups.forEach((group) => {
    const items = group.querySelectorAll('[data-accordion-item]');

    items.forEach((item) => {
      const { trigger, panel } = getParts(item);

      if (!trigger || !panel) {
        return;
      }

      panel.addEventListener('transitionend', (event) =>
        handleTransitionEnd(item, panel, event)
      );

      // Respect the initial markup: only items flagged `is-active` start open.
      if (item.classList.contains(ACTIVE_CLASS)) {
        expandItem(item, true);
      } else {
        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        panel.style.height = '';
      }

      trigger.addEventListener('click', () => {
        const isOpen = item.classList.contains(ACTIVE_CLASS);

        items.forEach((accordionItem) => {
          if (accordionItem !== item) {
            collapseItem(accordionItem);
          }
        });

        if (isOpen) {
          collapseItem(item);
        } else {
          expandItem(item);
        }
      });
    });
  });
}
